var _g, _g2, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiaryNotCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_4800_41638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.605 51.2358V45.4261C49.605 40.7611 53.3906 36.978 58.0556 36.978H72.139V16.8711C72.139 11.2334 67.5723 6.66663 61.9369 6.66663H16.869C11.2337 6.66663 6.66699 11.2334 6.66699 16.8711V79.7932C6.66699 85.4286 11.2337 89.9953 16.869 89.9953H61.9369C67.5723 89.9953 72.139 85.4286 72.139 79.7932V59.6864H58.0556C53.3881 59.6864 49.605 55.9033 49.605 51.2358Z",
    fill: "url(#paint0_linear_4800_41638)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_4800_41638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.4056 39.5278H58.0569C54.8044 39.5278 52.1562 42.1735 52.1562 45.426V51.2358C52.1562 54.4907 54.8044 57.1364 58.0569 57.1364H72.4056C75.6605 57.1364 78.3062 54.4907 78.3062 51.2358V45.426C78.3062 42.1735 75.6581 39.5278 72.4056 39.5278ZM60.6608 51.7344C58.7816 51.7344 57.261 50.2114 57.261 48.3321C57.261 46.4528 58.7816 44.9298 60.6608 44.9298C62.5401 44.9298 64.0632 46.4553 64.0632 48.3321C64.0632 50.2089 62.5401 51.7344 60.6608 51.7344Z",
    fill: "url(#paint1_linear_4800_41638)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_4800_41638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.018 17.3573C94.018 15.7998 92.7505 14.5322 91.1955 14.5322H88.3704C86.8105 14.5322 85.5479 15.7998 85.5479 17.3573V22.6904H94.0205L94.018 17.3573Z",
    fill: "url(#paint2_linear_4800_41638)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_4800_41638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.6641 25.6383V77.7589C83.6641 77.7589 86.0518 82.4166 87.9704 84.9665V88.187C87.9704 89.1893 88.7811 89.9999 89.7809 89.9999C90.7832 89.9999 91.5938 89.1893 91.5938 88.187V84.9665C93.5075 82.4166 95.8977 77.7589 95.8977 77.7589V25.6383H83.6641Z",
    fill: "url(#paint3_linear_4800_41638)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_4800_41638",
    x: 6.66699,
    y: -2.26374,
    width: 65.4717,
    height: 101.189,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -8.93037
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.46519
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.6776 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4800_41638"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.93037
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.46519
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423059 0 0 0 0 0.220647 0 0 0 0 0.454059 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_4800_41638",
    result: "effect2_innerShadow_4800_41638"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_4800_41638",
    x: 52.1562,
    y: 30.5975,
    width: 26.1504,
    height: 35.4693,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -8.93037
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.46519
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.6776 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4800_41638"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.93037
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.46519
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423059 0 0 0 0 0.220647 0 0 0 0 0.454059 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_4800_41638",
    result: "effect2_innerShadow_4800_41638"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_4800_41638",
    x: 85.5479,
    y: 5.60186,
    width: 8.47266,
    height: 26.0189,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -8.93037
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.46519
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.6776 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4800_41638"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.93037
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.46519
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423059 0 0 0 0 0.220647 0 0 0 0 0.454059 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_4800_41638",
    result: "effect2_innerShadow_4800_41638"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_4800_41638",
    x: 83.6641,
    y: 16.7079,
    width: 12.2334,
    height: 82.2224,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -8.93037
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.46519
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.6776 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4800_41638"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.93037
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.46519
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423059 0 0 0 0 0.220647 0 0 0 0 0.454059 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_4800_41638",
    result: "effect2_innerShadow_4800_41638"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4800_41638",
    x1: 39.403,
    y1: 6.66663,
    x2: 39.403,
    y2: 89.9953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85458E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4800_41638",
    x1: 65.2312,
    y1: 39.5278,
    x2: 65.2312,
    y2: 57.1364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85458E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4800_41638",
    x1: 89.7842,
    y1: 14.5322,
    x2: 89.7842,
    y2: 22.6904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85458E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4800_41638",
    x1: 89.7809,
    y1: 25.6383,
    x2: 89.7809,
    y2: 89.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85458E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiaryNotCompleted);
export default __webpack_public_path__ + "static/media/DiaryNotCompleted.4f8334d042fc2cb9ac22069003d37c0d.svg";
export { ForwardRef as ReactComponent };